import {ReactNode} from 'react';

import {textFieldCtx} from '../utils/textFieldCtx';
import {TextFieldContext} from '../utils/types';

interface TextFieldContextProviderProps extends TextFieldContext {
  children?: ReactNode;
}

export const TextFieldContextProvider = ({children, ...props}: TextFieldContextProviderProps) => (
  <textFieldCtx.Provider value={props}>{children}</textFieldCtx.Provider>
);
